import { WidgetHeader } from 'legacy/lut/components/widgets/public/partner360/widgetHeader/WidgetHeader'
import { useMemo } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'

import tr from './translations'

import styles from './ConfirmRevenueDialogContent.module.scss'

interface IProps {
  isRetailer: boolean

  onConfirm: () => void
  onClose: () => void
}

export const ConfirmRevenueDialogContent = ({ isRetailer, onConfirm, onClose }: IProps) => {
  const titleKey = useMemo(() => {
    return isRetailer ? tr.titleRetail : tr.title
  }, [isRetailer])

  const messageKey = useMemo(() => {
    return isRetailer ? tr.messageRetail : tr.message
  }, [isRetailer])

  return (
    <div className={styles.root}>
      <WidgetHeader>{titleKey}</WidgetHeader>
      <div className={styles.message}>
        <Translation text={messageKey} />
      </div>
      <div className={styles.buttons}>
        <Button onClick={onConfirm}>
          <Translation text={tr.apply} />
        </Button>
        <Button color="grey" onClick={onClose}>
          <Translation text={tr.cancel} />
        </Button>
      </div>
    </div>
  )
}
